import { addNotification } from "../notification/Notificationstore";
import { createSimpleListConfiguration, createSimpleListListFilter } from "../types/ListTypes";
import { _ } from "svelte-i18n";
import { get } from "svelte/store";
import { createTextBlock, deleteTextBlock, getTextBlocks, patchTextBlock as patchTextBlockApi } from "../api/EnzianDataApi";
import { handleStoreError } from "../stores/GeneralStore";
export function createTextBlockStore() {
    let textBlockStore = $state([]);
    let selectedTextBlock = $derived(textBlockStore.find((item) => item.selected) || null);
    let storeListeners = $state([]);
    //Filter for backend
    let listFilter = $state(createSimpleListListFilter({
        gridCols: 1,
        localStorageKey: 'text-blocks',
        filterOptions: [
            {
                label: get(_)('textblocksview.lbl_short_name'),
                key: 'shortName',
                value: null,
                type: 'string'
            }
        ]
    }));
    let listConfig = $state(createSimpleListConfiguration({
        header: get(_)('textblocksview.lbl_header'),
        growHeight: true,
        cardModeConfig: {
            gapSize: 2
        }
    }));
    async function loadData() {
        try {
            const data = await getTextBlocks(listFilter);
            if (listFilter.page == 0) {
                if (data.length > 0) {
                    data[0].selected = true;
                }
                //Reset the data.
                textBlockStore = data;
            }
            else {
                //Merge the lists
                textBlockStore.push(...data);
            }
            //Increase the page counter.
            if (data.length > 0) {
                listFilter.page += 1;
            }
        }
        catch (error) {
            handleStoreError('textblocksview.err_load_text_block', error);
        }
    }
    return {
        set data(value) { textBlockStore = value; },
        get data() {
            return textBlockStore;
        },
        get listFilter() { return listFilter; },
        set listFilter(value) { listFilter = value; },
        get listConfig() { return listConfig; },
        set listConfig(value) { listConfig = value; },
        get selectedTextBlock() { return selectedTextBlock; },
        addNotifier(listener) {
            storeListeners.push(listener);
        },
        removeNotifier(listener) {
            storeListeners = storeListeners.filter((li) => li == listener);
        },
        loadData: loadData,
        clear() {
            textBlockStore = [];
        },
        async applyFilter() {
            //Reset the start id
            listFilter.page = 0;
            //Load the data.
            await loadData();
            //Inform the listeners
            storeListeners.forEach((listener) => {
                //Call the event
                listener.onFilterApplied();
            });
        },
        async patchTextBlockInternal(targetId, patchTextBlock) {
            //Update the resource in the backed
            const patchedItem = await patchTextBlockApi(targetId, patchTextBlock);
            patchedItem.selected = true;
            //Update the resource in the original list
            const index = textBlockStore.findIndex(item => item.id == patchedItem.id);
            if (index < 0)
                return;
            textBlockStore[index] = patchedItem;
        },
        async handleDeleteTextBlockStore(targetId) {
            try {
                //Try to delete the text block on the server
                await deleteTextBlock(targetId);
                //Remove it from the data
                textBlockStore = textBlockStore.filter(listItem => listItem.id != targetId);
            }
            catch (error) {
                handleStoreError("textblocksview.err_delete_text_block", error);
            }
        },
        async createTextBlockInternal(shortName, name) {
            //Create the item on the backend
            try {
                var newItem = await createTextBlock({
                    shortName: shortName,
                    name: name,
                });
                addNotification({
                    message: get(_)("textblocksview.lbl_create_text_block_success"),
                    type: "success",
                });
                //Merge the data
                textBlockStore.push(newItem);
            }
            catch (error) {
                handleStoreError("textblocksview.err_create_text_block", error);
            }
        }
    };
}
